module.exports = __webpack_public_path__ + "assets/img/chef-2.5c403deb.jpg";